$ = require('jquery')

require('selectize')

module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.js-select').selectize(
			copyClassesToDropdown: false
			onChange: (value) ->
				urlRegex = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/

				if urlRegex.test(value)
					window.location.href = value
		)

		$target.find('.js-suggest').each(->
			$suggest = $(this)
			data = $suggest.data('suggest')

			defaultOptgroups = [
				{
					name: 'Kategorie'
					id: 'category'
				}
				{
					name: 'Textové výsledky'
					id: 'item'
				}
			]

			$suggest.selectize(
				copyClassesToDropdown: false
				plugins: ['restore_on_backspace']
				maxItems: 1
				valueField: 'value'
				labelField: 'text'
				searchField: ['text']
				optgroupField: 'field'
				optgroupValueField: 'id'
				optgroupLabelField: 'name'
				preload: true
				options: []
				optgroups: if data.optgroups? then data.optgroups else defaultOptgroups
				create: true
				persist: false
				render:
					option_create: (item, escape) ->
						return '<div class="create">Vyhledat <strong>' + escape(item.input) + '</strong>&hellip;</div>';
					optgroup: (item, escape) ->
						return '<div class="optgroup' + (if item.id is 'category' then ' optgroup-category' else '') + '">' + item.html + '</div>'
					optgroup_header: (item, escape) ->
						return '<div class="optgroup-header">' + escape(item.name) + '</div>'
					option: (item, escape) ->
						return '<div>' + escape(item.text) + '</div>'
				load: (query, callback) ->
					$.ajax(
						url: data.url + '?' + encodeURIComponent(query)
						type: 'GET'
						success: (data) ->
							callback(JSON.parse(data))
					)
				onChange: (value) ->
					$suggest[0].form.submit()
			)
		)



// WEBPACK FOOTER //
// ./src/js/components/selectize.coffee